import React, { useState, useEffect } from 'react';
import {BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';
import AOS from "aos"; 
import "aos/dist/aos.css";
import Navbar from './layout/Navbar';
import Home from './home/Home';
import Page404 from './404/Page404';
import Footer from './layout/Footer';
import PrivacyPolicy from './terms&privacy/PrivacyPolicy';
import Terms from './terms&privacy/Terms';

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");


  useEffect(() => {
    AOS.init({
      offset: 100, 
      duration: 800, 
      easing: 'ease-in-sine', 
      delay: 500,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    // Presumably you might want to perform some async operation here
  }

  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen bg-background dark:bg-darkbackground">
        <Navbar setTheme={setTheme}/>
        <Routes>
          <Route exact path='/' element={<Home/>} />
          <Route exact path='/aviso-de-privacidad' element={<PrivacyPolicy/>} />
          <Route exact path='/terminos-y-condiciones' element={<Terms/>} />
          <Route path='/404' element={<Page404/>} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
        <Footer theme={theme}/>
      </div>
    </BrowserRouter>
  );
}

export default App;